// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as RetroComponent} from './Retro.svg';

import Icon, { TIconProps } from '../Icon';

export const IconRetro = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <RetroComponent/>
  </Icon>
));
